import { Modal, Form, Input, Button, Switch, Select } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface TagFormValues {
    title: string;
    status: boolean;
    position: string;
}

interface TagModalProps {
    open: boolean;
    mode: "add" | "edit";
    initialValues?: TagFormValues;
    onCancel: () => void;
    onSubmit: (values: TagFormValues) => void;
    loading?: boolean;
}

export default function QuickModal({
    open,
    mode,
    initialValues,
    onCancel,
    onSubmit,
    loading,
}: TagModalProps) {

    const [form] = Form.useForm();
    const { t } = useTranslation();

    useEffect(() => {
        if (open) {
            form.setFieldsValue(
                initialValues || {
                    title: "",
                    is_active: true,
                    position: "chat",
                }
            );
        }
    }, [open, initialValues, form]);

    const handleFinish = (values: TagFormValues) => {
        onSubmit(values);
    };

    return (
        <Modal
            title={mode === "add" ? t('quick_message.modal_add') : t('quick_message.modal_edit')}
            open={open}
            onCancel={() => {
                form.resetFields();
                onCancel();
            }}
            footer={null}
            centered
        >
            <Form form={form} layout="vertical" onFinish={handleFinish}>

                {/* Tiêu đề */}
                <Form.Item
                    label={t('quick_message.label_title')}
                    name="title"
                    rules={[{ required: true, message: t('quick_message.title_required') }]}
                >
                    <Input />
                </Form.Item>

                {/* Trạng thái */}
                <Form.Item
                    label={t('quick_message.label_status')}
                    name="is_active"
                    valuePropName="checked"
                >
                    <Switch
                        className="custom-switch"
                        checkedChildren={t('quick_message.switch_on')}
                        unCheckedChildren={t('quick_message.switch_off')}
                    />
                </Form.Item>

                {/* Vị trí */}
                <Form.Item
                    label={t('quick_message.label_position')}
                    name="position"
                    rules={[{ required: true, message: t('quick_message.position_required') }]}
                >
                    <Input type="number" />
                </Form.Item>

                <div className="flex justify-end gap-2 pt-4 border-t">
                    <Button onClick={onCancel}>{t('quick_message.cancel')}</Button>

                    <Button
                        htmlType="submit"
                        type="primary"
                        loading={loading}
                        className="!bg-[#3e91ab] hover:!bg-[#357f96] border-none"
                    >
                        OK
                    </Button>
                </div>

            </Form>
        </Modal>
    );
}